import Button from "@/common/components/Button";
import { Link } from "react-router-dom";

const NegotiationsListEmptyState = () => {
  return (
    <div className="h-[calc(100vh-128px)] flex gap-6 items-center justify-center px-24 select-none">
      <div className="flex flex-col gap-4">
        <p className="text-2xl font-bold">Nenhuma negociação ativa.</p>

        <p>
          Encontre estabelecimentos e inicie uma negociação para obter preços especiais nos produtos que você mais utiliza.
        </p>

        <Link to="/establishments">
          <Button>
            Ir até rede credenciada
          </Button>
        </Link>
      </div>

      <img src="/negotiations-empty-state.png" className="pointer-events-none" />
    </div>
  );
};

export default NegotiationsListEmptyState;
